import styled from 'styled-components';
import { Table } from 'components/generic';
import { getColor } from 'utils';
export const NameContainer = styled('div')`
    padding-right: 0.5rem;
    width: 18rem;
`;

export const MemberContainer = styled(Table)`
    border: 0.0625rem solid #ccc;
    border-radius: 0.25rem;
    border-color: ${props => getColor(props, 'mediumGrey')};
`;